import { css } from 'styled-components'

/**
 * Reusable tier color styles
 */
export const tierGradientBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
  }
`

/**
 * Tier darkBackground color styles (for icon badges, accent backgrounds)
 */
export const tierDarkBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.darkBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.darkBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.darkBackground};
  }
`

/**
 * Tier lightContrast color styles (for text on gradient backgrounds)
 */
export const tierLightContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.lightContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.lightContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.lightContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.lightContrast};
  }
`

/**
 * Tier normalContrast background color styles (for dividers, accents)
 */
export const tierNormalContrastBackgroundStyle = css`
  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

/**
 * Tier darkContrast color styles (for text on dark tier backgrounds)
 */
export const tierDarkContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.darkContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.darkContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
  }
`

/**
 * Tier normalBackground styles (for badge/label backgrounds)
 */
export const tierNormalBackgroundStyle = css`
  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalBackground};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalBackground};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalBackground};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
  }
`

/**
 * Tier normalContrast color styles (for text)
 */
export const tierNormalContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

/**
 * Tier normalBackground + normalContrast styles (for tier-colored badges/labels)
 */
export const tierNormalBadgeStyle = css`
  ${tierNormalBackgroundStyle}
  ${tierNormalContrastColorStyle}
`

/**
 * Tier gradient secondary background (e.g. banner pills, secondary panels).
 */
export const tierGradientSecondaryBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientSecondaryBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientSecondaryBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientSecondaryBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientSecondaryBackground};
  }
`
